import { useRecipeQuickCommentsQuery } from "@chef/state-management";

interface UseQuickCommentsForSelectedRating {
  rating: number;
}

export const useQuickCommentsForSelectedRating = ({
  rating,
}: UseQuickCommentsForSelectedRating) => {
  const {
    data: recipeQuickCommentsQuery,
    isLoading: isLoadingRecipeQuickCommentsQuery,
  } = useRecipeQuickCommentsQuery();

  const quickCommentsForRating = recipeQuickCommentsQuery?.recipeQuickComments
    ?.filter((comment) => comment.nrOfStars === rating)
    .sort((a, b) => a.quickComment.localeCompare(b.quickComment));

  const quickCommentIdsForSelectedRating = quickCommentsForRating?.map(
    (qc) => qc.id,
  );

  return {
    quickCommentsForRating,
    quickCommentIdsForSelectedRating,
    isLoadingRecipeQuickCommentsQuery,
  };
};
